let isUser = JSON.parse(localStorage.getItem('authUser'));


export default {
  enableActions: state => {
    return state.enableActions;
  },
  
  // Fetch new user
  authUserName: state => {
    return state.authUser.name;
  },
  
  authUsername: state => {
    return state.authUser.username
  },
  
  authUserPhonenumber: state => {
    return state.authUser.phoneNumber
  },
  
  // Fetch bank Notification state
  authUserEmail: state => {
    return state.authUser.email
  },
  
  // Fetch Settlement Accounts
  authUserBusinessName: state => {
    return state.authUser.businessName
  },
  
  authUserBusinessType: state => {
    return state.authUser.businessType
  },

  authUserBusinessDescription: state => {
    return state.authUser.businessDescription
  },

}



// WEBPACK FOOTER //
// ./src/store/getters.js